import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RootState } from '../../../store';

interface SelectionState<T = unknown> {
    selectedRows: number[];
    selectedRowsItems: T[];
}

const initialState: SelectionState = {
    selectedRows: [],
    selectedRowsItems: [],
};

export const selectionSlice = createSlice({
    name: 'selection',
    initialState,
    reducers: {
        setSelectedRows(state, action: PayloadAction<number[]>) {
            state.selectedRows = action.payload;
        },
        setSelectedRowsItem(state, action) {
            state.selectedRowsItems = action.payload;
        },
        addSelectedRow(state, action: PayloadAction<number>) {
            if (!state.selectedRows.includes(action.payload)) {
                state.selectedRows.push(action.payload);
            }
        },
        removeSelectedRow(state, action: PayloadAction<number>) {
            state.selectedRows = state.selectedRows.filter(
                id => id !== action.payload
            );
        },
        clearSelection(state) {
            state.selectedRows = [];
            state.selectedRowsItems = [];
        },
    },
});

export const {
    setSelectedRows,
    setSelectedRowsItem,
    addSelectedRow,
    removeSelectedRow,
    clearSelection,
} = selectionSlice.actions;

export const selectSelected = (state: RootState) => state.selection;

export const selectionReducer = selectionSlice.reducer;
